import React from 'react'

const AddonsOverage = ({ addons }) => {
  const {
    additionalPublishedApps,
    additionalTeamMembers,
    publishedAppsOverageAmount,
    teamMembersOverageAmount,
  } = addons

  return (
    <>
      {additionalPublishedApps ? (
        <>
          <div className="clear-left left">
            Additional Published Apps x{additionalPublishedApps}
          </div>
          <div className="clear-right right">
            ${publishedAppsOverageAmount.toLocaleString('en-US')}
          </div>
        </>
      ) : null}
      {additionalTeamMembers ? (
        <>
          <div className="clear-left left">
            Additional Editor Seats x{additionalTeamMembers}
          </div>
          <div className="clear-right right">
            ${teamMembersOverageAmount.toLocaleString('en-US')}
          </div>
        </>
      ) : null}
    </>
  )
}

export default AddonsOverage
